import { Info } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface KpiCardProps {
  label: string;
  value: string;
  tooltip: string;
  /** Optional second line, e.g. the unpriced count. Rendered only when given. */
  secondLine?: string;
}

export function KpiCard({ label, value, tooltip, secondLine }: KpiCardProps) {
  return (
    <Card className="flex-1 min-w-0">
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-3">
          <span className="text-sm text-muted-foreground">{label}</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <button type="button" aria-label={`About ${label}`}>
                <Info className="h-3.5 w-3.5 text-muted-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="max-w-[200px]">
              {tooltip}
            </TooltipContent>
          </Tooltip>
        </div>
        <div className="text-2xl font-semibold text-foreground tracking-tight">{value}</div>
        {secondLine ? <div className="text-xs text-muted-foreground">{secondLine}</div> : null}
      </CardContent>
    </Card>
  );
}
